import { Link } from "react-router-dom"

const Header = ({active}) => {

    return (
        <ul className="navbar-nav bg-gradient-primary sidebar sidebar-dark accordion" id="accordionSidebar">

            <Link className="sidebar-brand d-flex align-items-center justify-content-center" to="/dashboard" >
                <div className="sidebar-brand-text mx-3">Prontuário Coluço</div>
            </Link>

            <hr className="sidebar-divider my-0" />

            <li className={`nav-item ${active === 'dashboard' ? 'active' : ''}`}>
                <Link className="nav-link" to="/dashboard">
                    <i className="fas fa-fw fa-tachometer-alt"></i>
                    <span>Dashboard</span></Link>
            </li>

            <hr className="sidebar-divider" />

            <div className="sidebar-heading">
                Novo
            </div>

            <li className={`nav-item ${active === 'newPatient' ? 'active' : ''}`}>
                <Link className="nav-link" to="/patients/new">
                    <i className="fas fa-fw fa-user"></i>
                    <span>Novo Paciente</span></Link>
            </li>

            <li className={`nav-item ${active === 'newTreatment' ? 'active' : ''}`}>
                <Link className="nav-link" to="/treatments/new">
                    <i className="fas fa-fw fa-calendar-plus"></i>
                    <span>Novo Atendimento</span></Link>
            </li>

            <li className={`nav-item ${active === 'newExam' ? 'active' : ''}`}>
                <Link className="nav-link" to="/exams/new">
                    <i className="fas fa-fw fa-file-medical-alt"></i>
                    <span>Novo Exame</span></Link>
            </li>

            <li className={`nav-item ${active === 'typeExam' ? 'active' : ''}`}>
                <Link className="nav-link" to="/addexams">
                    <i className="fas fa-fw fa-file-medical-alt"></i>
                    <span>Tipos de Exames</span></Link>
            </li>

            <hr className="sidebar-divider" />

            <div className="sidebar-heading">
                Geral
            </div>

            <li className={`nav-item ${active === 'patients' ? 'active' : ''}`}>
                <Link className="nav-link" to="/patients">
                    <i className="fas fa-fw fa-users"></i>
                    <span>Pacientes</span></Link>
            </li>

            <li className={`nav-item ${active === 'treatments' ? 'active' : ''}`}>
                <Link className="nav-link" to="/treatments">
                    <i className="fas fa-fw fa-calendar"></i>
                    <span>Atendimentos</span></Link>
            </li>

            <li className={`nav-item ${active === 'exams' ? 'active' : ''}`}>
                <Link className="nav-link" to="/exams">
                    <i className="fas fa-fw fa-file-medical-alt"></i>
                    <span>Exames</span></Link>
            </li>

            <hr className="sidebar-divider d-none d-md-block" />

        </ul>
    )
}

export default Header
